import React from 'react';
import './Banner.css';
import { Cursor, useTypewriter } from 'react-simple-typewriter';
import { FaFacebook, FaGithub, FaLinkedin, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { Link } from 'react-router-dom';

const Banner = () => {
    const bannerImage = 'https://i.ibb.co/hgygmvH/Shakil-AHamed.jpg';

    const [text] = useTypewriter({
        words: ['MERN Stack Developer','App Developer', 'Crypto Analyst'],
        loop: {},
        typeSpeed: 40,
        deleteSpeed: 10,
    })

    return (
        <div className='banner-section bg-indigo-950'>
            <div className="wave wave1"></div>
            <div className="wave wave2"></div>
            <div className="wave wave3"></div>
            <div className="wave wave4"></div>

            <div className='min-h-[70vh] flex items-center justify-between px-5 md:px-20 lg:px-32 max-w-[1400px] m-auto'>
                <div className='w-full' data-aos='fade-up'>
                    <h1 className='text-4xl font-bold md:text-4xl lg:text-5xl'>Shakil Ahamed</h1>
                    <h1 className='text-xl font-bold mb-4'>I'm a_
                        <br className='lg:hidden' />
                        <span className='text-teal-300'> {text}</span>
                        <span className='text-teal-300 font-bold text-4xl'><Cursor cursorStyle='_'></Cursor></span>
                    </h1>
                    <p className='opacity-70 mb-4'>I'm a Web & App Developer with over 3 years of experience. My expertise lies in frontend development, design, and backend development <Link to={'/skills'} className='text-cyan-300 hover:text-cyan-400'>see more...</Link></p>

                    <Link to='/contact'>
                        <button className="btn btn-outline text-teal-300 mt-5 btn-sm rounded-md px-10 mb-8">Hire Me</button>
                    </Link>

                    <div className='flex gap-4'>
                        <Link to='https://www.facebook.com/sakil2171' target='_blank' className='border rounded-full p-2 border-teal-300 text-sm text-teal-300 hover:text-white'>
                            <FaFacebook></FaFacebook>
                        </Link>
                        <Link to='https://twitter.com/ShakilA42712830' target='_blank' className='border rounded-full p-2 border-teal-300 text-sm text-teal-300 hover:text-white'>
                            <FaTwitter></FaTwitter>
                        </Link>
                        <Link to='https://wa.me/+8801794267010?text=Hello,' target='_blank' className='border rounded-full p-2 border-teal-300 text-sm text-teal-300 hover:text-white'>
                            <FaWhatsapp></FaWhatsapp>
                        </Link>
                        <Link to='https://github.com/Sakil71' target='_blank' className='border rounded-full p-2 border-teal-300 text-sm text-teal-300 hover:text-white'>
                            <FaGithub></FaGithub>
                        </Link>
                        <Link to='https://www.linkedin.com/in/shakil-ahamed-097164177/' target='_blank' className='border rounded-full p-2 border-teal-300 text-sm text-teal-300 hover:text-white'>
                            <FaLinkedin></FaLinkedin>
                        </Link>
                    </div>
                </div>
                <div className='hidden md:block lg:block xl:block w-3/4 rounded-full' data-aos='fade-down'>
                    <div className='banner-container'>
                        <img className='banner-image rounded-full' src={bannerImage} alt="" />
                        <div className='banner-earth'></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;